import React from "react";
import { AppShell } from "@mantine/core";
import { useChat } from "./ChatContext";

export default function ChatAwareAppShell({ opened, children, ...props }) {
  const { open } = useChat();
  return (
    <AppShell
      {...props}
      navbar={{
        width: 250,
        breakpoint: "sm",
        collapsed: { mobile: !opened, desktop: open },
      }}
    >
      {children}
    </AppShell>
  );
}
